module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dropdown-confirmation', {
    attrs: {
      "size": "lg",
      "direction": "left",
      "triggerBtnClass": "btn-light",
      "triggerBtnHtml": "<i class=\"fa fa-exchange\"></i>&nbsp;&nbsp;Merge Account",
      "confirmBtnClass": "btn-primary",
      "confirmBtnHtml": "<i class=\"fa fa-check\"></i>&nbsp;&nbsp;Merge Account"
    },
    on: {
      "confirm": _vm.mergeAccount
    }
  }, [_vm._t("default", [_c('div', {
    staticStyle: {
      "width": "45%",
      "font-weight": "400",
      "display": "inline-block",
      "vertical-align": "top",
      "padding": "0 10px 0 0"
    }
  }, [_c('p', [_vm._v("Choose an account to merge with:")]), _vm._v(" "), _c('label', [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.merge.name),
      expression: "merge.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm._s(_vm.merge.name)
    },
    on: {
      "keyup": _vm.searchAccounts,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.merge.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_vm._v("Carrier")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.merge.carrier_name),
      expression: "merge.carrier_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm._s(_vm.merge.carrier_name)
    },
    on: {
      "keyup": _vm.searchAccounts,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.merge.carrier_name = $event.target.value
      }
    }
  })]), _c('div', {
    staticStyle: {
      "width": "55%",
      "font-weight": "400",
      "display": "inline-block",
      "vertical-align": "top",
      "padding": "0 0 0 0px",
      "overflow-y": "scroll",
      "height": "175px",
      "border": "1px solid #e2e2e2"
    }
  }, _vm._l((_vm.accounts), function(account) {
    return _c('div', {
      staticClass: "merge-result-row",
      class: {
        active: account.account_id == _vm.merge_account_id
      },
      on: {
        "click": function($event) {
          _vm.setMergeAccount(account)
        }
      }
    }, [_c('div', [_vm._v(_vm._s(account.name))])])
  }))])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5b038392!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/accounts/MergeAccount.vue
// module id = 393
// module chunks = 0